export default __webpack_public_path__ + "fc17195fe3f9e24858bec36791c643a7.png";